import { useEffect } from "react";
import { useState } from "react";
import { getUserHierarchy } from "../../services/organizationHierarchy";
import { toast } from "react-toastify";
import Header from "../../components/Header";
import OrganizationHierarchy from "../../components/organization-hierarchy/OrganizationHierarchy";
import useLoader from "../../hooks/useLoader";
import HierarchyFilter from "../../components/organization-hierarchy/HierarchyFilter";
import useAuthUser from "../../hooks/useAuthUser";
import { Link } from "react-router-dom";

const HierarchyPage = () => {
  const { showLoader, hideLoader } = useLoader();
  const { loggedInUser } = useAuthUser();
  const loggedInUserId = Number(loggedInUser?.id) || null;
  const [highlightedUserId, setHighlightedUserId] = useState(loggedInUserId);
  const userRole = Number(loggedInUser?.role);
  const isEmployee = userRole === 7;
  const [data, setData] = useState({
    hierarchy: [],
    reportees: [],
    photoPath: "",
    loggedInUserManagerId: null,
  });
  const fetchData = async (userId = null) => {
    try {
      showLoader();
      const response = await getUserHierarchy(userId);
      if (response.data && response.data.data) {
        setData(response.data.data);

        if (userId) {
          setHighlightedUserId(userId);
        }
      } else if (response.data.status !== 200) {
        toast.error(response.data.message || "Failed to fetch hierarchy data");
      }
    } catch (error) {
      console.error("Error fetching hierarchy data:", error);
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message || "Data not found");
      } else {
        toast.error(
          error.response.data.message ||
            error.message ||
            "An error occurred while fetching hierarchy data"
        );
      }
    } finally {
      hideLoader();
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleClick = (userId) => {
    setHighlightedUserId(userId);
    fetchData(userId);
  };
  const handleDownload = () => {
    const selectors = [
      ".dashboard-inner-left-col",
      ".top-dashboard-header",
      "h1.heading",
      "span.add",
      ".hierarchy-filter",
      "h1.dashboard",
      ".copyright-content",
    ];
    const elements = selectors.map((sel) =>
      Array.from(document.querySelectorAll(sel))
    );
    elements.forEach((els) => els.forEach((el) => (el.style.display = "none")));
    window.print();
    elements.forEach((els) => els.forEach((el) => (el.style.display = "")));
  };
  return (
    <div>
      <Header title="Organization Hierarchy">
        <span className="add float-end">
          <Link
            to="#"
            className="btn btn-success btn-sm"
            onClick={handleDownload}
          >
            <span className="material-icons-outlined ms-0">download</span>
            <span className="text">Download</span>
          </Link>
        </span>
      </Header>
      {!isEmployee && (
        <HierarchyFilter
          fetchData={fetchData}
          setHighlightedUserId={setHighlightedUserId}
        />
      )}

      {/* <div id="org-hierarchy-pdf"> */}
      <OrganizationHierarchy
        hierarchy={data.hierarchy}
        reportees={data.reportees}
        photoPath={data.photoPath}
        onClick={handleClick}
        loggedInUserManagerId={data.loggedInUserManagerId}
        highlightedUserId={highlightedUserId}
      />
      {/* </div> */}
    </div>
  );
};

export default HierarchyPage;
